import BasePagination from 'components/atoms/base-pagination';
import { type FC } from 'react';
import BaseTableNew from 'components/atoms/base-table/new';
import { scrollToTopAsync } from 'infrastructure/functions';
import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import { useTranslation } from 'react-i18next';
import {
  NORMAL_READINGS_REPORT_PER_PAGE,
  useGetNormalReadingsReport,
  type TNormalReadingsFilter,
} from 'infrastructure/hooks/normal-reading-report';

import { columns } from './columns';
import ReadingCounter from './reading-counter';
import s from './styles.module.scss';

interface NormalReadingsTableProps {
  filter: TNormalReadingsFilter;
  updateFilter: (newFilter: Partial<TNormalReadingsFilter>) => void;
}

const NormalReadingsTable: FC<NormalReadingsTableProps> = ({
  filter,
  updateFilter,
}) => {
  const { t } = useTranslation();
  const { data, isLoading, isFetching } = useGetNormalReadingsReport(filter);
  const loading = isLoading || isFetching;

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <ReadingCounter {...(data?.readingCount ?? {})} />
        <BasePagination
          page={filter?.page}
          total={data?.count ?? 0}
          align="end"
          onChange={async (newPage) => {
            updateFilter({ page: newPage });
          }}
          pageSize={NORMAL_READINGS_REPORT_PER_PAGE}
          pageSizeOptions={[]}
          hide={false}
          showSizeChanger={false}
        />
      </div>
      <div className={s.divider} />
      <div id="normal-readings-table">
        <BaseTableNew
          dataCy="normal-readings-table"
          loading={loading}
          columns={columns(filter.page)}
          items={data?.data ?? []}
          bordered
          pagination={{
            current: filter.page,
            pageSize: NORMAL_READINGS_REPORT_PER_PAGE,
            total: data?.count ?? 0,
            position: ['bottomCenter'],
            showSizeChanger: false,
          }}
          onChangePage={(newPage) => {
            scrollToTopAsync('normal-readings-table', 70).then(() => {
              updateFilter({ page: newPage });
            });
          }}
          emptyText={
            <EmptyTablePlaceholder text={t('labels.noReadingsFound')} column />
          }
          rowHoverable={false}
        />
      </div>
    </div>
  );
};
export default NormalReadingsTable;
